import script from "./ComponentSandboxDynamicV3.vue?vue&type=script&lang=js"
export * from "./ComponentSandboxDynamicV3.vue?vue&type=script&lang=js"

export default script